import { makeStyles, useTheme } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.sideBar.backgroundColor,
    zIndex: 1000,
    position: 'sticky',
    left: 0,
    top: 10,
    width: 25,
    boxShadow: '3px 0 5px rgba(0,0,0,.1)',
    borderRadius: '0 4px 4px 0',

    '& .MuiSvgIcon-root': {
      fill: theme.palette.text.primary
    }
  }
}))

export {
  useStyles,
  useTheme
}
